import React, { useState } from 'react';
import { X } from 'lucide-react';

const Portfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const portfolioImages = [
    {
      id: 1,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/m26divgf_IMG-20251113-WA0015.jpg',
      title: 'Banyo Tadilatı - Bayraklı',
      description: 'Seramik ve armatür montajı'
    },
    {
      id: 2,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/dlx3iiwn_IMG-20251113-WA0016.jpg',
      title: 'Banyo Yenileme - Bornova',
      description: 'Komple banyo renovasyonu'
    },
    {
      id: 3,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/fqydltzf_IMG-20251113-WA0012.jpg',
      title: 'Modern Banyo - Karşıyaka',
      description: 'Tesisat ve duşakabin montajı'
    },
    {
      id: 4,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/xlsizn8n_IMG-20251113-WA0013.jpg',
      title: 'Banyo Tadilat Projesi',
      description: 'Seramik döşeme ve tesisat'
    },
    {
      id: 5,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/ysencvr2_IMG-20251113-WA0014.jpg',
      title: 'Banyo Yenileme İşi',
      description: 'Duvar ve zemin seramiği'
    },
    {
      id: 6,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/9mumcdxx_IMG-20251113-WA0017.jpg',
      title: 'Havuz Yapımı - Urla',
      description: 'Havuz inşaatı ve tesisat'
    },
    {
      id: 7,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/2a0e09aj_IMG-20251113-WA0018.jpg',
      title: 'Teras Havuzu Projesi',
      description: 'Su tesisatı ve zemin kaplaması'
    },
    {
      id: 8,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/2v76fnx9_IMG-20251113-WA0019.jpg',
      title: 'Dış Mekan Havuzu',
      description: 'Havuz ve çevre düzenlemesi'
    },
    {
      id: 9,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/pfzlckwq_IMG-20251113-WA0020.jpg',
      title: 'Villa Havuz Projesi',
      description: 'Tesisat ve zemin işleri'
    },
    {
      id: 10,
      src: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/pwdbe4xt_IMG-20251113-WA0021.jpg',
      title: 'Mutfak Tadilatı - Konak',
      description: 'Su tesisatı yenileme'
    },
    {
      id: 11,
      src: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800',
      title: 'Su Kaçağı Tespiti',
      description: 'Kameralı sistem ile tespit'
    },
    {
      id: 12,
      src: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800',
      title: 'Petek Temizleme İşi',
      description: 'Profesyonel makine ile temizlik'
    },
    {
      id: 13,
      src: 'https://images.unsplash.com/photo-1604079628040-94301bb21b91?w=800',
      title: 'Tesisat Revizyonu',
      description: 'Boru yenileme ve montaj'
    },
    {
      id: 14,
      src: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800',
      title: 'Kanal Açma Hizmeti',
      description: 'Görüntülü tıkanıklık açma'
    },
    {
      id: 15,
      src: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=800',
      title: 'Mutfak Tesisat İşleri',
      description: 'Lavabo ve musluk montajı'
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24">
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gradient-gold">Örnek İşlerimiz</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Tamamladığımız projelerden örnekler. Kaliteli işçilik ve profesyonel hizmetin kanıtı.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {portfolioImages.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-xl cursor-pointer card-hover"
                onClick={() => setSelectedImage(image)}
              >
                <div className="aspect-square overflow-hidden bg-zinc-900">
                  <img
                    src={image.src}
                    alt={image.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1">{image.title}</h3>
                    <p className="text-gray-300 text-sm">{image.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-gradient-to-r from-zinc-900 to-zinc-800 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Siz de <span className="text-gradient-gold">Kaliteli İşçilik</span> İster misiniz?
            </h2>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Profesyonel ekibimiz ve kaliteli malzemelerimizle hayalinizdeki projeyi gerçeğe dönüştürelim.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={`tel:05300137282`}>
                <button className="px-8 py-3 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-600 transition-colors">
                  Hemen Ara
                </button>
              </a>
              <a href={`https://wa.me/905345644143`} target="_blank" rel="noopener noreferrer">
                <button className="px-8 py-3 border-2 border-yellow-500 text-yellow-500 font-semibold rounded-lg hover:bg-yellow-500 hover:text-black transition-colors">
                  WhatsApp'tan Yaz
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-yellow-500 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <div className="max-w-5xl w-full">
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg"
            />
            <div className="mt-6 text-center">
              <h3 className="text-2xl font-bold text-white mb-2">{selectedImage.title}</h3>
              <p className="text-gray-400">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Portfolio;
